import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import Find from '../../share/components/Find/Find'
import CarouselServices, { servicesTravel } from '../../share/components/CarouselServices/CarouselSevices'
import BannerDetail from './BannerDetail/BannerDetail'
import FirstInfo from './FirtsInfo/FirstInfo'
import InfoDetailDoctor from './InfoDetailDoctor/InfoDetailDoctor'
import GaleryDoctor from './GaleryDoctor/GaleryDoctor'
import MakeAppointment from './makeAppointment/MakeAppointment'
import ModalQuo from './ModalQuo/ModalQuo'
import UseDetailSpecialist from '../../../viewModels/specialist/UseDetailSpecialist'


const DetailSpecialist = () => {
  const { state } = useLocation();
  

  const {
    sendInformation,
    name,
    setName,
    email,
    setEmail,
    error,
    succesScreen,
    description,
    setDescription,
    tel,
    setTel,
    subject,
    setSubject,
    setModal,
    modal,
    loadingS
  } = UseDetailSpecialist()


  return (
    <div className='contain-detail-specialist'>
      <Find />
      <CarouselServices current={servicesTravel[7].title} />
      <BannerDetail name={state.name} specialist={state.subCategories} urlImage={state.urlImage} pathImage={state.pathImage} setModal={setModal} />
      <FirstInfo stars={state.infoDoctor.stars} cities={state.offices} setModal={setModal} />
      <InfoDetailDoctor infoDoctor={state.infoDoctor.description} infoSpecialist={state.infoDoctor.speciality} offices={state.offices} urlImage={state.urlImage} specialist={state.subCategories} />
      <MakeAppointment address={state.offices} />
      <GaleryDoctor urlImage={state.urlImage} images={state.images} />
      {
        modal &&
        <ModalQuo
          setModal={setModal}
          description={description}
          setDescription={setDescription}
          email={email}
          setEmail={setEmail}
          tel={tel}
          setTel={setTel}
          name={name}
          setName={setName}
          subject={subject}
          setSubject={setSubject}
          sendInformation={sendInformation}
          succesScreen={succesScreen}
          error={error}
          id={state.id}
          loading={loadingS}
        />
      }

    </div>
  )
}

export default DetailSpecialist